// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"style_skeletonWrapper__UMPnU"};